import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    id: 'yourPrivacyChoicesModal.header',
    defaultMessage: 'Your Privacy Choices',
  },
  description: {
    id: 'yourPrivacyChoicesModal.description',
    defaultMessage: '“Do Not Sell or Share My Personal Information” and “Targeted Advertising” Opt-Out Rights',
  },
  privacyPolicy: {
    id: 'yourPrivacyChoicesModal.privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
  saleSharingAndTargetedAdvertisingSubtitle: {
    id: 'yourPrivacyChoicesModal.saleSharingAndTargetedAdvertisingSubtitle',
    defaultMessage: 'Sale, Sharing, and Targeted Advertising',
  },
  saleSharingAndTargetedAdvertisingBodyText1: {
    id: 'yourPrivacyChoicesModal.saleSharingAndTargetedAdvertisingBodyText1',
    defaultMessage: 'Certain states provide residents or their authorized agents with the right to opt out of:',
  },
  saleSharingAndTargetedAdvertisingListItem1: {
    id: 'yourPrivacyChoicesModal.saleSharingAndTargetedAdvertisingListItem1',
    defaultMessage: 'the “selling” or “sharing” of their personal information, or',
  },
  saleSharingAndTargetedAdvertisingListItem2: {
    id: 'yourPrivacyChoicesModal.saleSharingAndTargetedAdvertisingListItem2',
    defaultMessage: '“targeted advertising” using their personal information.',
  },
  saleSharingAndTargetedAdvertisingBodyText2: {
    id: 'yourPrivacyChoicesModal.saleSharingAndTargetedAdvertisingBodyText2',
    defaultMessage:
      'Many of these states define "sale" as disclosing or making available personal information to a third party in exchange for monetary or other valuable consideration. California defines “sharing” as disclosing or making available personal information to a third party for purposes of cross-contextual behavioral advertising, and states that provide for a right to opt out of “targeted advertising” define that term as similar to California’s definition of “sharing.”',
  },
  saleSharingAndTargetedAdvertisingBodyText3: {
    id: 'yourPrivacyChoicesModal.saleSharingAndTargetedAdvertisingBodyText3',
    defaultMessage:
      'While we do not disclose personal information to third parties in exchange for monetary compensation, we may be considered “selling” or “sharing” personal information due to our use of ad and analytics cookies and other tools. We "sell" or "share" the following categories of personal information: identifiers (such as name, email address and telephone number), location information, language, device information, and information relating to how you interact with our services. We disclose these categories to third-party advertising networks, analytics providers, and social networks for purposes of marketing and advertising. We do not sell or share personal information about individuals we know are under 16.',
  },
  optOutSubtitle: {
    id: 'yourPrivacyChoicesModal.optOutSubtitle',
    defaultMessage: 'Opt-Out',
  },
  optOutBodyText1: {
    id: 'yourPrivacyChoicesModal.optOutBodyText1',
    defaultMessage:
      'To opt out of targeted advertising, or the sale or sharing of your personal information, or to adjust your previously-set preferences, you may adjust your settings by clicking "Cookie Preferences" below and following the instructions:',
  },
  cookiePreferences: {
    id: 'yourPrivacyChoicesModal.cookiePreferences',
    defaultMessage: 'Cookie Preferences',
  },
  optOutBodyText2: {
    id: 'yourPrivacyChoicesModal.optOutBodyText2',
    defaultMessage:
      'You also have the right to opt out through the use of an opt-out preference signal. If our website detects that your browser or device is transmitting an opt-out preference signal, such as the “global privacy control”—or GPC— signal, we will opt that browser or device out of cookies on our website that result in a sale or sharing of your personal information, or targeted advertising using your personal information.',
  },
  optOutBodyText3: {
    id: 'yourPrivacyChoicesModal.optOutBodyText3',
    defaultMessage:
      'Please note that your opt-out choice is specific to the website or subdomain you are browsing and to the device and browser you are using. If you access our other websites or subdomains, you will need to make a separate choice, or use an opt-out preference signal, for each. Additionally, if you clear your cookies on your browser or use another browser or device, you may need to opt out again.',
  },
  optOutBodyText4: {
    id: 'yourPrivacyChoicesModal.optOutBodyText4',
    defaultMessage:
      'You or your authorized agent may also opt out by <contact-us-link>contacting us here.</contact-us-link>',
  },
  sensitivePersonalInformationSubtitle: {
    id: 'yourPrivacyChoicesModal.sensitivePersonalInformationSubtitle',
    defaultMessage: 'Sensitive Personal Information',
  },
  sensitivePersonalInformationBodyText: {
    id: 'yourPrivacyChoicesModal.sensitivePersonalInformationBodyText',
    defaultMessage:
      'California provides residents a right to limit the use of their sensitive personal information. However, we do not engage in uses or disclosures of sensitive personal information that would trigger the right to limit under California law.',
  },
  moreInformationSubtitle: {
    id: 'yourPrivacyChoicesModal.moreInformationSubtitle',
    defaultMessage: 'More Information',
  },
  moreInformationBodyText: {
    id: 'yourPrivacyChoicesModal.moreInformationBodyText',
    defaultMessage:
      'For more information about how we collect and use personal information, please see the <privacy-policy-link>ClassPass Privacy Policy.</privacy-policy-link>',
  },
});
